import { render } from "./LeadershipDetailView.vue?vue&type=template&id=339948f9&ts=true"
import script from "./LeadershipDetailView.vue?vue&type=script&lang=ts"
export * from "./LeadershipDetailView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__